import { nanoid } from "nanoid";
import dayjs from "dayjs";
import { getFingerPrint } from "./finger";
import { getDuration } from "@utiles/index";
const SESSION_INFO_KEY = "officialguide_point_session_info";

let windowDataLayerName = "";
let startTime = new Date();

const dealStorageAction = {
  // 首次初始化
  initSessionId: async () => {
    setSessionInfo({
      sid: await getNewSessionId(),
      sount: 1,
      activeTime: getNowTime(),
    });
    startTime = new Date();
    window[windowDataLayerName].push({
      eventName: "session_start",
      eventIsFirst: "1",
    });
  },
  // 更新sessionId、count+1
  updateSessionId: async () => {
    const sessionInfo = getSessionInfo();
    setSessionInfo({
      sid: await getNewSessionId(),
      sount: sessionInfo?.sount + 1 || 1,
      activeTime: getNowTime(),
    });
    sendSessionEndPoint();
    startTime = new Date();
    window[windowDataLayerName].push({
      eventName: "session_start",
      eventIsFirst: "0",
    });
  },
  // 仅更新时间
  updateTime: async () => {
    const sessionInfo = getSessionInfo();
    if (!sessionInfo?.sid) {
      dealStorageAction.initSessionId();
    } else {
      setSessionInfo({
        sid: sessionInfo.sid,
        sount: sessionInfo?.sount || 1,
        activeTime: getNowTime(),
      });
    }
  },
};

export const sendSessionEndPoint = () => {
  const duration = getDuration(startTime);
  window[windowDataLayerName].push({
    eventName: "session_end",
    eventValue: {
      duration,
    },
  });
};

export const handleSessionId = (dataLayerName) => {
  windowDataLayerName = dataLayerName;
  initPageVisibilityChange();
  initSessionId();
};

const initSessionId = () => {
  const sessionInfo = getSessionInfo();
  if (!sessionInfo?.sid) {
    dealStorageAction.initSessionId();
    return;
  }
  if (sessionInfo?.activeTime && checkOverMinute(sessionInfo.activeTime)) {
    dealStorageAction.updateSessionId();
  } else {
    dealStorageAction.updateTime();
  }
};

const getHiddenProperty = () => {
  if ("hidden" in document) {
    return "hidden";
  }
  if ("webkitHidden" in document) {
    return "webkitHidden";
  }
  if ("mozHidden" in document) {
    return "mozHidden";
  }
  return null;
};

const initPageVisibilityChange = () => {
  const hiddenProperty = getHiddenProperty();

  const visibilityChangeEvent = hiddenProperty.replace(
    /hidden/i,
    "visibilitychange"
  );
  const onVisibilityChange = function () {
    if (!document[hiddenProperty]) {
      initSessionId();
    } else {
      dealStorageAction.updateTime();
    }
  };
  document.addEventListener(visibilityChangeEvent, onVisibilityChange);
};

export const getNewSessionId = async () => {
  const fingerTxt = await getFingerPrint();
  const idLength = 25;
  return nanoid(idLength) + "_" + fingerTxt;
};

const checkOverMinute = (time) => {
  return dayjs(new Date()).diff(dayjs(time), "minute") > 1;
};

const getNowTime = () => {
  return dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
};

export const getSessionInfo = () => {
  let sessionInfo = "";
  try {
    sessionInfo = JSON.parse(localStorage.getItem(SESSION_INFO_KEY));
  } catch (e) {
    console.log(e);
  }
  return sessionInfo;
};

const setSessionInfo = ({ sid, sount, activeTime }) => {
  try {
    localStorage.setItem(
      SESSION_INFO_KEY,
      JSON.stringify({
        sid,
        sount,
        activeTime,
      })
    );
  } catch (e) {
    console.log(e);
  }
};
